import { matchPath } from 'react-router-dom';
import { CHECKOUT_PATH } from '../config/routes';

function isCheckoutRoutePathname(pathname) {
    if (typeof pathname !== 'string') {
        return false;
    }

    return matchPath(pathname, { path: CHECKOUT_PATH, exact: true }) !== null;
}

export default isCheckoutRoutePathname;
